import { PayloadAction } from "@reduxjs/toolkit";
import { ProposalReduxState, ResumeFieldsType } from "../types";
import { Guarantees } from "../../../../components/CommercialConditions/partials/ResumenConditions/partials/info/GuaranteeFields/GuaranteeFields";

const UpdateResumenFields = <K extends keyof ResumeFieldsType>(
  state: ProposalReduxState,
  {
    payload: { key, value },
  }: PayloadAction<{
    key: K;
    value: ResumeFieldsType[K];
  }>,
) => {
  state.resumeFields[key] = value;

  state.isUpdated = true;
};

const UpdateMultiResumenFields = (
  state: ProposalReduxState,
  { payload }: PayloadAction<Partial<ResumeFieldsType>>,
) => {
  state.resumeFields = {
    ...(state.resumeFields || {}),
    ...payload,
  };

  state.isUpdated = true;
};

const UpdateGuaranteesFields = (
  state: ProposalReduxState,
  { payload }: PayloadAction<Guarantees>,
) => {
  state.guarantees = { ...state.guarantees, ...payload };
  state.isUpdated = true;
};

const ResumenFieldsReducer = {
  UpdateResumenFields,
  UpdateMultiResumenFields,
  UpdateGuaranteesFields,
};

export default ResumenFieldsReducer;
